// Import model
import { DataviewIndividualContactResponse } from '../models/DataviewIndividualContactResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterIndividualContactRequest } from '../models/FilterIndividualContactRequest';
import { IndividualContact } from '../models/IndividualContact';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterIndividualContactRequestSerializer } from './FilterIndividualContactRequestSerializer';
import { IndividualContactSerializer } from './IndividualContactSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewIndividualContactResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewIndividualContactResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewIndividualContactResponse instance
   */
  static deserialize(json: string): DataviewIndividualContactResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewIndividualContactResponse instance
   */
  static fromObject(obj: any): DataviewIndividualContactResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewIndividualContactResponse');
    }


    const instance: DataviewIndividualContactResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        IndividualContactSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterIndividualContactRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewIndividualContactResponse instances
   */
  static deserializeArray(json: string): DataviewIndividualContactResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewIndividualContactResponse instance to a JSON string
   */
  static serialize(instance: DataviewIndividualContactResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewIndividualContactResponse instance to a plain object
   */
  static toObject(instance: DataviewIndividualContactResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        IndividualContactSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterIndividualContactRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewIndividualContactResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewIndividualContactResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
